<template>
<div class="nav-header" ref="navHeader">
    <div class="flex">
      <div 
        class="nav-item nav-item-1" 
        :class="{ active: selectedNav === '特色农产品' }"
        @click="handleClick('特色农产品')"
      >
        
      </div>
    </div>
    <div class="flex">
      <div 
        class="nav-item nav-item-2" 
        :class="{ active: selectedNav === '都市农业' }"
        @click="handleClick('都市农业')"
      >
      </div>
    </div>
    <div class="flex">
      <div 
        class="nav-item nav-item-3" 
        :class="{ active: selectedNav === '农业文化遗产' }"
        @click="handleClick('农业文化遗产')"
      >
      </div>
    </div>
    <div class="flex">
      <div 
        class="nav-item nav-item-4" 
        @click="routeClick('')"
      >
      </div>
    </div>
    <!-- <div 
      class="nav-item " 
      :class="{ active: selectedNav === '特色农事体验和乡村非遗活动' }"
      @click="handleClick('特色农事体验和乡村非遗活动')"
    >
      特色农事体验和乡村非遗活动
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'NavHeader',
  props: {
    selectedNav: {
      type: String,
      default: '特色农产品'
    }
  },
  watch: {
    selectedNav() {
      this.$nextTick(() => {
        this.scrollActiveIntoView()
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollActiveIntoView()
    })
  },
  methods: {
    scrollActiveIntoView() {
      const container = this.$refs.navHeader
      if (!container) return
      const activeEl = container.querySelector('.nav-item.active')
      if (!activeEl || typeof activeEl.scrollIntoView !== 'function') return
      activeEl.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      })
    },
    handleClick(category) {
      this.$emit('nav-click', category)
    },
    routeClick() {
      this.$emit('nav-click-4')
    }
  }
}
</script>

<style scoped>
/* 顶部导航栏 */
.nav-header {
  width: 100%;
  height: 91px;
  /* background-color: #eefff9;  */
  background-image: url("https://lbs-nfncb.nfncb.cn/gzmap/img/nav_bg.png");
  background-size: 100% 100%;
  /* overflow-x: auto;
  white-space: nowrap; */
  z-index: 1000;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

/* 透明滚动条 */
.nav-header::-webkit-scrollbar {
  height: 0; /* 隐藏高度，透明效果 */
  background: transparent;
}

.nav-header {
  scrollbar-width: none; /* Firefox 隐藏滚动条 */
}

.flex {
  display: flex;
  width: 150px;
  height: 60px;
  align-items: center;
  justify-content: center;
}

.nav-item {
  display: inline-block;
  /* min-width: 200px; */
  color: #004e44;
  font-size: 26px;
  text-align: center;
  user-select: none;
  /* transition: all 0.3s; */
  width: 120px;
  height: 40px;
}
.nav-item-1 {
  background-image: url("https://lbs-nfncb.nfncb.cn/gzmap/img/nav1.png");
  background-size: 100% 100%;
}
.nav-item-2 {
  background-image: url("https://lbs-nfncb.nfncb.cn/gzmap/img/nav2.png");
  background-size: 100% 100%;
}
.nav-item-3 {
  background-image: url("https://lbs-nfncb.nfncb.cn/gzmap/img/nav3.png");
  background-size: 100% 100%;
}
.nav-item-4 {
  background-image: url("https://lbs-nfncb.nfncb.cn/gzmap/img/nav4.png");
  background-size: 100% 100%;
}

.nav-item-1.active {
  width: 135px;
  height: 53px;
  background-image: url("https://lbs-nfncb.nfncb.cn/gzmap/img/nav1_on.png");
  background-size: 100% 100%;
}
.nav-item-2.active {
  width: 135px;
  height: 53px;
  background-image: url("https://lbs-nfncb.nfncb.cn/gzmap/img/nav2_on.png");
  background-size: 100% 100%;
}
.nav-item-3.active {
  width: 135px;
  height: 53px;
  background-image: url("https://lbs-nfncb.nfncb.cn/gzmap/img/nav3_on.png");
  background-size: 100% 100%;
}
</style>

